const HandleLinkClickPlugin = {
	install (Vue) {
	
		Vue.prototype.$handleLinkClick = function ($event, wrapperSelectors) {
			const {
				target
			} = $event

			// if hashtag, scroll to that part of the page
			if (target && target.href && target.href.indexOf("#") != -1) {
				let parts = target.href.split("#")
				if (
					parts[0]===(location.origin+location.pathname) ||
					(location.hostname==='localhost' && parts[0].includes('localhost'))
				) {
					let targetId = parts.pop();
					if (document.getElementById(targetId)) {
						$event.preventDefault()
						this.$scrollTo(targetId, 700)
						return
					}
				}
			}
			
			// handle only links that occur inside the component and do not reference external resources
			if (target && target.matches(wrapperSelectors) && target.href) {
				if (target.href.includes(location.hostname) === false) return;
				// some sanity checks taken from vue-router:
				// https://github.com/vuejs/vue-router/blob/dev/src/components/link.js#L106
				const {
					altKey,
					ctrlKey,
					metaKey,
					shiftKey,
					button,
					defaultPrevented
				} = $event
				// don't handle with control keys
				if (metaKey || altKey || ctrlKey || shiftKey) return
				// don't handle when preventDefault called
				if (defaultPrevented) return
				// don't handle right clicks
				if (button !== undefined && button !== 0) return
				// don't handle if `target="_blank"`
				if (target && target.getAttribute) {
					const linkTarget = target.getAttribute('target')
					if (/\b_blank\b/i.test(linkTarget)) return
				}
				// don't handle same page links/anchors
				const url = new URL(target.href)
				const to = url.pathname
				if (window.location.pathname !== to && $event.preventDefault) {
					$event.preventDefault()
					this.$router.push(to)
				}
			}
		}
	}
}

export default HandleLinkClickPlugin